import React, { useEffect, useState } from 'react'
import { IZdsIcon, ZdsIcon } from '@zera/components'
import { AnimatePresence } from 'framer-motion'
import { CloseButton, Container, Description, Title } from './styles'
import { Stack } from '~/styles'

export interface HatAlertProps {
  show?: boolean
  title?: string
  description?: string
  icon?: IZdsIcon['src']
  extraElement?: React.ReactNode
}

export const HatAlert = ({
  show: showProp = false,
  title,
  description,
  icon,
  extraElement
}: HatAlertProps): JSX.Element => {
  const [show, setShow] = useState<boolean>(showProp)

  useEffect(() => {
    setShow(showProp)
  }, [showProp])

  return (
    <AnimatePresence>
      {show && (
        <Container initial={{ height: 0 }} animate={{ height: 'auto' }} exit={{ height: 0 }} layout>
          <Stack direction="row" justifyContent="space-between" padding="16px 24px">
            <Stack direction="row" justifyContent="center" flex={1}>
              {icon && <ZdsIcon src={icon} width={16} height={16} color="neutral100" dataTestId="hat-alert-icon" />}

              {title && <Title>{title}</Title>}
              {description && <Description>{description}</Description>}

              {extraElement && extraElement}
            </Stack>

            <CloseButton onClick={() => setShow(false)} />
          </Stack>
        </Container>
      )}
    </AnimatePresence>
  )
}
